import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import apiPhoneNumber from '@drivesally/sally-fw/lib/type/types/apiPhoneNumber.type';
import phoneNumber from '@drivesally/sally-fw/lib/type/types/phoneNumber.type';

export default attribute({
  type: TEXT,
  attribute: 'garage_phone_number',
  display: phoneNumber,
  input: phoneNumber,
  api: apiPhoneNumber,
  label: {
    default: 'Garage Phone Number',
    short: 'Phone Number',
  },
});
